"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processPhysicsEventQueue = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var crokinolePucks_sidecar_1 = require("../entities/crokinolePucks-sidecar");
var crokinoleDefs_sidecar_1 = require("../main/crokinoleDefs-sidecar");
var crokinoleSounds_sidecar_1 = require("../sound/crokinoleSounds-sidecar");
var physics_rapier_loader_sidecar_1 = require("./physics_rapier_loader-sidecar");
var namespace = 'crokinolePhysics_contactHandler';
var processPhysicsEventQueue = function (eventQueue) {
    var phys = physics_rapier_loader_sidecar_1.physics_rapier_loader.get();
    eventQueue.drainCollisionEvents(function (handle1, handle2, started) {
        if (crokinoleDefs_sidecar_1.crokinoleDefs.debugCollisions) {
            // console.log(namespace, 'collision!') // , handle1, handle2, started)
        }
        // A collision event!
        if (!started) {
            return; // TODO: needed to handle 'end' of collision
        }
        var c1 = phys.world.colliders.get(handle1);
        var c2 = phys.world.colliders.get(handle2);
        if (!c1 || !c2) {
            console.log(namespace, 'missing collider handle!', handle1, handle2, c1, c2);
            return;
        }
        var _b1 = c1.parent();
        var _b2 = c2.parent();
        if (!_b1 || !_b2) {
            console.log(namespace, 'missing rigid body!', _b1, _b2);
            return;
        }
        var _user1 = _b1 === null || _b1 === void 0 ? void 0 : _b1.userData;
        var _user2 = _b2 === null || _b2 === void 0 ? void 0 : _b2.userData;
        if (!_user1 || !_user2) {
            console.log(namespace, 'missing user data!', _user1, _user2);
            return;
        }
        var _handled = false;
        var onTypeCollision = function (t1, t2, b1, b2, cb) {
            if (_user1.type === t1 && _user2.type === t2) {
                _handled = true;
                if (crokinoleDefs_sidecar_1.crokinoleDefs.debugCollisions) {
                    console.log(namespace, t1 + " hit " + t2 + "!", handle1, handle2, started);
                }
                cb(b1, b2);
            }
            else if (_user1.type === t2 && _user2.type === t1) {
                _handled = true;
                if (crokinoleDefs_sidecar_1.crokinoleDefs.debugCollisions) {
                    console.log(namespace, t2 + " hit " + t1 + "!", handle1, handle2, started);
                }
                cb(b2, b1);
            }
        };
        onTypeCollision('puck', 'puck', _b1, _b2, function (b1, b2) {
            var puck1 = crokinolePucks_sidecar_1.crokinolePucks.tryGetFromHandle(b1.handle);
            var puck2 = crokinolePucks_sidecar_1.crokinolePucks.tryGetFromHandle(b2.handle);
            assert_sidecar_1.assert.notNil(puck1, 'missing puck1');
            assert_sidecar_1.assert.notNil(puck2, 'missing puck2');
            if (crokinoleDefs_sidecar_1.crokinoleDefs.debugCollisions) {
                console.log(namespace, 'puck collision!', puck1, puck2, started);
            }
            puck1.wasHitThisTurn = true;
            puck2.wasHitThisTurn = true;
            crokinoleSounds_sidecar_1.crokinoleSounds.playPieceContactsPiece();
        });
        onTypeCollision('puck', 'pole', _b1, _b2, function (b1, b2) {
            crokinoleSounds_sidecar_1.crokinoleSounds.playPieceContactsPole();
        });
        onTypeCollision('puck', 'boundary', _b1, _b2, function (b1, b2) {
            crokinoleSounds_sidecar_1.crokinoleSounds.playPieceContactsBoundary();
        });
        onTypeCollision('puck', 'playarea', _b1, _b2, function (b1, b2) {
            crokinoleSounds_sidecar_1.crokinoleSounds.playPieceContactsBoundary();
        });
        if (!_handled) {
            console.log('unhandled collision between', _user1.type, _user2.type);
        }
        // if (user1.type === 'pole' && user2.type === 'puck') {
        //   crokinoleSounds.playPieceContactsPole()
        // } else if (user1.type === 'puck' && user2.type === 'pole') {
        //   crokinoleSounds.playPieceContactsPole()
        // } else if (user1.type === 'puck' && user2.type === 'boundary') {
        //   crokinoleSounds.playPieceContactsBoundary()
        // } else if (user1.type === 'boundary' && user2.type === 'puck') {
        //   crokinoleSounds.playPieceContactsBoundary()
        // } else {
        //   if (crokinoleDefs.debugCollisions) {
        //     console.log('unhandled collision between', user1.type, user2.type)
        //   }
        // }
        // } else if (user1.type === 'puck' && user2.type === 'hole') {
        //   crokinoleSounds.playPieceInHole()
        // } else if (user1.type === 'hole' && user2.type === 'puck') {
        //   crokinoleSounds.playPieceInHole()
        // } else {
        //   console.log('collision!', handle1, handle2, started)
        // }
    });
};
exports.processPhysicsEventQueue = processPhysicsEventQueue;
